import { gql } from '@apollo/client'

export const UPDATE_TEAM_NAME = gql`
  mutation UpdateTeamName($fantasyLeagueMemberId: ID!, $teamName: String!) {
    updateTeamName(input: { fantasyLeagueMemberId: $fantasyLeagueMemberId, teamName: $teamName }) {
      fantasyLeagueMember {
        id
        teamName
      }
      errors
    }
  }
`
